// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_scrollable_content-module__container--1uQXO{width:100%;-webkit-box-flex:1;-webkit-flex:1 1 auto;-moz-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow-y:auto;height:auto;-webkit-overflow-scrolling:touch}\n", ""]);
// Exports
exports.locals = {
	"container": "modal_scrollable_content-module__container--1uQXO"
};
module.exports = exports;
